import { Group } from "./group.model";

export class NewGroup{
    constructor(
        public groups: Array<Group> = new Array<Group>(),
        public merchantId: String = '',
        public operators: Array<any> = Array<any>(),
        public name: String = '',
        public code: String = '',
        public description: String = '',
        public groupId: String = ''
    ){}
}